import React from 'react';
import AppLogo from '@/components/ui/AppLogo';

export default function Footer() {
  const year = new Date()?.getFullYear();

  return (
    <footer className="border-t border-border bg-offwhite">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-14">
        {/* Arc Browser Split pattern */}
        <div className="flex flex-col md:flex-row justify-between items-start gap-8">
          {/* Left: Logo + tagline */}
          <div className="space-y-2">
            <AppLogo src="/assets/images/EMT_Sync-1771523582374.png" text="EMT Sync" size={32} />
            <p className="text-xs text-muted font-500 max-w-[220px] leading-relaxed">
              Wdrożenia BaseLinker i Apilo.<br />Migracje i automatyzacje sprzedaży.
            </p>
          </div>

          {/* Center: Contact Info */}
          <div className="space-y-3">
            <p className="text-xs font-700 uppercase tracking-widest text-navy">Kontakt</p>
            <div className="space-y-2">
              <a href="mailto:kontakt.emtgroup@gmail.com" className="block text-sm font-600 text-muted hover:text-navy transition-colors">
                kontakt.emtgroup@gmail.com
              </a>
              <a href="tel:+48882639186" className="block text-sm font-600 text-muted hover:text-navy transition-colors">
                882-639-186
              </a>
              <p className="text-sm font-600 text-muted">
                Barczewo, Polska
              </p>
            </div>
          </div>

          {/* Right: Links */}
          <div className="flex flex-wrap gap-x-8 gap-y-3">
            <a href="#dla-kogo" className="text-sm font-600 text-muted hover:text-navy transition-colors">Dla kogo</a>
            <a href="#integracje" className="text-sm font-600 text-muted hover:text-navy transition-colors">Integracje</a>
            <a href="#migracja" className="text-sm font-600 text-muted hover:text-navy transition-colors">Migracja</a>
            <a href="#pakiety" className="text-sm font-600 text-muted hover:text-navy transition-colors">Pakiety</a>
            <a href="#faq" className="text-sm font-600 text-muted hover:text-navy transition-colors">FAQ</a>
            <a href="#kontakt" className="text-sm font-600 text-muted hover:text-navy transition-colors">Kontakt</a>
          </div>
        </div>

        {/* Bottom row */}
        <div className="mt-10 pt-6 border-t border-border flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-xs text-muted font-500">
            © {year} EMT Sync. Wszelkie prawa zastrzeżone.
          </p>
          <div className="flex gap-6">
            <a href="#" className="text-xs font-600 text-muted hover:text-navy transition-colors">Polityka prywatności</a>
            <a href="#" className="text-xs font-600 text-muted hover:text-navy transition-colors">Regulamin</a>
          </div>
        </div>

        {/* SEO keywords hidden visually but accessible */}
        <div className="sr-only">
          wdrożenie baselinker, wdrożenie apilo, migracja baselinker do apilo,
          automatyzacje baselinker, integracja allegro amazon prestashop,
          faktury oss automatyzacja
        </div>
      </div>
    </footer>
  );
}